<nz-spin [nzSpinning]="cardLoading">
  <section>
    <div class="container py-8 space-y-[20px]">
      <nz-card *ngIf="this.singleItinerary?.tour?.customer" class="px-8 py-8 md:px-12 md:py-8 bg-white space-y-[20px]">
        <h4>{{ 'itineraries.costBreakdown.clientTourInformation.title' | transloco }}</h4>
        <nz-divider></nz-divider>
        <div class="grid  md:grid-cols-3 grid-cols-1">
          <div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.costBreakdown.clientTourInformation.name' | transloco }}: </p>
              <p
                class="text-[#444444]">{{ this.singleItinerary?.tour?.customer?.first_name + " " + this.singleItinerary?.tour?.customer?.last_name }}</p>
            </div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.costBreakdown.clientTourInformation.email' | transloco }}: </p>
              <p class="text-[#444444]"> {{ singleItinerary?.tour?.customer?.email || getEmptyValue() }}</p>
            </div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.costBreakdown.clientTourInformation.country' | transloco }}: </p>
              <img height="20px" width="20px"
                   [src]="this.findCountryFlagImage(this.singleItinerary?.tour?.customer?.country?.code)"
                   alt="country">
              <p class="text-[#444444]">{{ this.singleItinerary?.tour?.customer?.country?.name }}</p>
            </div>
          </div>
          <div>
            <div *ngIf="!this.singleItinerary?.tour?.isDatesOptional" class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.costBreakdown.clientTourInformation.dates' | transloco }}: </p>
              <p
                class="text-[#444444]">
                {{
                  this.customizeDate(this.singleItinerary?.tour?.startDate, 'Do') + " - " +
                  this.customizeDate(this.singleItinerary?.tour?.endDate, 'Do MMM, YYYY')
                }}
              </p>
            </div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.costBreakdown.clientTourInformation.numberOfDays' | transloco }}: </p>
              <p class="text-[#444444]">
                {{ this.singleItinerary?.tour?.noOfDays | number : '2.0' }}
                {{ getNumberOfDaysLabel(this.singleItinerary?.tour?.noOfDays) }}
              </p>
            </div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.costBreakdown.clientTourInformation.numberOfPax' | transloco }}: </p>
              <p class="text-[#444444]">{{ this.singleItinerary?.tour?.pax?.adults | number : '2.0' }} <span
                class="ml-0.5 text-[12px]">{{ 'itineraries.costBreakdown.clientTourInformation.adults' | transloco }}</span></p>
              <p class="text-[#444444]">{{ this.singleItinerary?.tour?.pax?.children | number : '2.0' }} <span
                class="ml-0.5 text-[12px]">{{ 'itineraries.costBreakdown.clientTourInformation.children' | transloco }}</span></p>
              <p class="text-[#444444]">{{ this.singleItinerary?.tour?.pax?.infants | number : '2.0' }} <span
                class="ml-0.5 text-[12px]">{{ 'itineraries.costBreakdown.clientTourInformation.infants' | transloco }}</span></p>

            </div>
          </div>
          <div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.costBreakdown.clientTourInformation.currency' | transloco }}: </p>
              <p
                class="text-[#444444]">
                {{ this.singleItinerary?.tour?.currency }}
              </p>
            </div>
            <div class="flex flex-row gap-2" *ngIf="this.singleItinerary?.tour?.secondaryCurrency">
              <p class="text-[#444444]">{{ 'itineraries.costBreakdown.clientTourInformation.secondaryCurrency' | transloco }}: </p>
              <p
                class="text-[#444444]">
                {{ this.singleItinerary?.tour?.secondaryCurrency }}
              </p>
            </div>
            <div class="flex flex-row gap-2" *ngIf="this.singleItinerary?.tour?.secondaryCurrency">
              <p class="text-[#444444]">{{ 'itineraries.costBreakdown.clientTourInformation.exchangeRate' | transloco }}: </p>
              <p
                class="text-[#444444]">
                {{ this.singleItinerary?.tour?.exchangeRate }}
              </p>
            </div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.costBreakdown.clientTourInformation.language' | transloco }}: </p>
              <p class="text-[#444444]">
                {{ findLanguageByCode(singleItinerary?.tour?.language) }}
              </p>
            </div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.costBreakdown.clientTourInformation.costingType' | transloco }}: </p>
              <p class="text-[#444444]">{{ getCostingTypeLabel() }}</p>

            </div>
          </div>
        </div>
      </nz-card>
      <div *ngIf="!this.singleItinerary?.costSettings?.isSubTotalManual && !this.singleItinerary?.costing?.costBreak" class=" space-y-[20px]">
        <nz-card class="space-y-[20px] pb-5 px-8 py-8 md:px-12 md:py-8 bg-white" *ngFor="let day of this.singleItinerary?.days; let i = index">
          <div class="" *ngIf="day.destination && (!this.singleItinerary?.viewSettings?.isDepartureChecked ||
                  i !== this.singleItinerary?.days.length - 1);
              else isDepartureBlock
            ">
            <ng-container *ngIf="!day.isLeisureDay">
              <h4>
                {{ getDayLabel(i + 1) }} - {{
                  this.displayTitle(
                    day?.destination?.titles,
                    this.singleItinerary.tour.language
                  )
                }} {{ !this.singleItinerary?.tour?.isDatesOptional
                ? '(' + (day.date | date:'d MMM y' | uppercase) + ')'
                : "" }}
              </h4>
            </ng-container>
            <ng-container *ngIf="day.isLeisureDay">
              <h4>
                {{ getDayLabel(i + 1) }} - {{ getLeisureDayLabel() }} {{ !this.singleItinerary?.tour?.isDatesOptional
                ? '(' + (day.date | date:'d MMM y' | uppercase) + ')'
                : "" }}
              </h4>
            </ng-container>
            <nz-divider></nz-divider>
            <div  class="space-y-[15px]"
                 *ngIf="getAccommodationPerDate(day.date, this.singleItinerary.accommodation).length !== 0 && !day.isLeisureDay ">
              <div class="flex flex-row justify-between">
                <div>
                  <h4>{{ 'itineraries.costBreakdown.accommodation.title' | transloco }}</h4>
                  <span class="text-sm text-gray-500">
                    {{ getVatLabel(getAccommodationPerDate(day.date, this.singleItinerary.accommodation)[0]?.isTaxed) }}
                    {{ getAccommodationPerDate(day.date, this.singleItinerary.accommodation)[0]?.isTaxed ? ' (' + accVatPercentage + '%)' : '' }}
                  </span>
                </div>
                <h4>{{ this.currency }}
                  {{ calculateAccommodationPerDay(getAccommodationPerDate(day.date, this.singleItinerary.accommodation))| number:'1.2-2' }}
                </h4>
              </div>
              <div class="grid grid-cols-12 gap-y-5">
                <div class="col-span-9">
                  <nz-table #accTable [nzSize]="'small'" [nzScroll]="{ x: '600px' }"
                            [nzData]="getAccommodationPerDate(day.date, this.singleItinerary.accommodation)[0].rooms"
                            [nzShowPagination]="false" [nzBordered]="true">
                    <thead>
                    <tr>
                      <th nzWidth="20%">{{ 'itineraries.costBreakdown.accommodation.roomCategory' | transloco }}</th>
                      <th nzWidth="20%">{{ 'itineraries.costBreakdown.accommodation.roomType' | transloco }}</th>
                      <th nzWidth="20%">{{ 'itineraries.costBreakdown.accommodation.mealType' | transloco }}</th>
                      <th nzWidth="15%">{{ 'itineraries.costBreakdown.accommodation.roomRate' | transloco }}</th>
                      <th nzWidth="10%">{{ 'itineraries.costBreakdown.accommodation.numberOfRooms' | transloco }}</th>
                      <th nzWidth="15%">{{ 'itineraries.costBreakdown.accommodation.totalCost' | transloco }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of accTable.data">
                      <td>{{ data.roomCategory }}</td>
                      <td>{{ data.roomType }}</td>
                      <td>{{ data.mealType }}</td>
                      <td>
                        {{ this.currency }}
                        {{
                          (getAccommodationPerDate(day.date, this.singleItinerary.accommodation)[0].isPrimaryCurrency  ? data.roomRate : convertAmount(exchangeRate, data.roomRate) ) | number:'1.2-2'
                        }}
                      </td>
                      <td>{{ data.noOfRooms }}</td>
                      <td>
                        {{ this.currency }}
                        {{
                          (getAccommodationPerDate(day.date, this.singleItinerary.accommodation)[0].isPrimaryCurrency ? data.cost : convertAmount(exchangeRate, data.cost) ) | number:'1.2-2'
                        }}
                      </td>
                    </tr>
                    </tbody>
                  </nz-table>
                </div>
                <ng-container *ngFor="let acc of getAccommodationPerDate(day.date, this.singleItinerary.accommodation)">
                  <div class="col-span-9" *ngIf="acc?.extraCost && acc.extraCost.length > 0">
                    <p class="font-semibold mb-1">{{ 'itineraries.costBreakdown.accommodation.extraCosts' | transloco }}</p>
                    <nz-table #extraCostTable [nzSize]="'small'" [nzScroll]="{ x: '500px' }"
                              [nzData]="acc.extraCost"
                              [nzShowPagination]="false" [nzBordered]="true">
                      <thead>
                      <tr>
                        <th nzWidth="40%">{{ 'itineraries.costBreakdown.accommodation.name' | transloco }}</th>
                        <th nzWidth="25%">{{ 'itineraries.costBreakdown.accommodation.baseRate' | transloco }}</th>
                        <th *ngIf="acc?.isTaxed" nzWidth="15%">{{ 'itineraries.costBreakdown.accommodation.vatPercentage' | transloco }}</th>
                        <th nzWidth="25%">{{ 'itineraries.costBreakdown.accommodation.cost' | transloco }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let extra of extraCostTable.data">
                        <td>{{ extra.name }}</td>
                        <td>
                          {{ this.currency }}
                          {{ (acc?.isPrimaryCurrency ? (extra.baseRate ?? extra.cost) : convertAmount(exchangeRate, (extra.baseRate ?? extra.cost))) | number:'1.2-2' }}
                        </td>
                        <td *ngIf="acc?.isTaxed">
                          {{ accVatPercentage }}%
                        </td>
                        <td>
                          {{ this.currency }}
                          {{ (acc?.isPrimaryCurrency ? extra.cost : convertAmount(exchangeRate, extra.cost)) | number:'1.2-2' }}
                        </td>
                      </tr>
                      </tbody>
                    </nz-table>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <ng-template #isDepartureBlock>
            <h4>
              {{ getDayLabel(i + 1) }} - {{ getDepartureLabel() }} {{ !this.singleItinerary?.tour?.isDatesOptional
              ? '(' + (day.date | date:'d MMM y' | uppercase) + ')'
              : "" }}
            </h4>
          </ng-template>
          <div *ngIf="day.transport.length !== 0" class="space-y-[15px] mt-7">
            <div class="flex flex-row justify-between">
              <h4>{{ 'itineraries.costBreakdown.transport.title' | transloco }}</h4>
              <h4>{{ this.currency }} {{ this.calculateTransportTotalCostPerDay(day.transport) | number:'1.2-2' }}</h4>
            </div>
            <div class="grid grid-cols-12" *ngIf="sortTransportByLand(day.transport).length !== 0">
              <div class="col-span-9">
                <nz-table #transportLandTable [nzSize]="'small'" [nzScroll]="{ x: '600px' }"
                          [nzData]="sortTransportByLand(day.transport)"
                          [nzShowPagination]="false" [nzBordered]="true">
                  <thead>
                  <tr>
                    <th nzWidth="20%">{{ 'itineraries.costBreakdown.transport.from' | transloco }}</th>
                    <th nzWidth="20%">{{ 'itineraries.costBreakdown.transport.to' | transloco }}</th>
                    <th nzWidth="15%">{{ 'itineraries.costBreakdown.transport.modeOfTravel' | transloco }}</th>
                    <th nzWidth="10%">{{ 'itineraries.costBreakdown.transport.mileageKm' | transloco }}</th>
                    <th nzWidth="25%">{{ 'itineraries.costBreakdown.transport.costPerMileageKm' | transloco }}</th>
                    <th nzWidth="10%">{{ 'itineraries.costBreakdown.transport.driverBata' | transloco }}</th>
                    <th nzWidth="15%">{{ 'itineraries.costBreakdown.transport.totalCost' | transloco }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let data of transportLandTable.data">
                    <td>{{ data.displayNameFrom }}</td>
                    <td>{{ data.displayNameTo }}</td>
                    <td>{{ getTransportModeLabel(data.typeOfVehicle) }}</td>
                    <td>{{ data.mileage }}</td>
                    <td>
                      {{ this.currency }}
                      {{
                        (data?.isPrimaryCurrency ? data.costPerMileage : convertAmount(exchangeRate, data.costPerMileage)) | number:'1.2-2'
                      }}
                    </td>
                    <td>
                      {{ this.currency }}
                      {{
                        (data?.isPrimaryCurrency  ? data.driverBata  : convertAmount(exchangeRate, data.driverBata ) ) | number:'1.2-2'
                      }}
                    </td>
                    <td>
                      {{ this.currency }}
                      {{
                        (data?.isPrimaryCurrency  ? data.totalCost  : convertAmount(exchangeRate, data.totalCost )) | number:'1.2-2'
                      }}
                    </td>
                  </tr>
                  </tbody>
                </nz-table>
              </div>
            </div>
            <div class="grid grid-cols-12" *ngIf="sortTransportByNotLand(day.transport).length !== 0">
              <div class="col-span-9">
                <nz-table #transportNotLandTable [nzSize]="'small'" [nzScroll]="{ x: '600px' }"
                          [nzData]="sortTransportByNotLand(day.transport)"
                          [nzShowPagination]="false" [nzBordered]="true">
                  <thead>
                  <tr>
                    <th nzWidth="20%">{{ 'itineraries.costBreakdown.transport.from' | transloco }}</th>
                    <th nzWidth="20%">{{ 'itineraries.costBreakdown.transport.to' | transloco }}</th>
                    <th nzWidth="15%">{{ 'itineraries.costBreakdown.transport.modeOfTravel' | transloco }}</th>
                    <th nzWidth="20%">{{ 'itineraries.costBreakdown.transport.mileageKm' | transloco }}</th>
                    <th nzWidth="15%">{{ 'itineraries.costBreakdown.transport.costPerAdult' | transloco }}</th>
                    <th nzWidth="15%">{{ 'itineraries.costBreakdown.transport.costPerChild' | transloco }}</th>
                    <th nzWidth="15%">{{ 'itineraries.costBreakdown.transport.costPerInfant' | transloco }}</th>
                    <th nzWidth="15%">{{ 'itineraries.costBreakdown.transport.totalCost' | transloco }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let data of transportNotLandTable.data">
                    <td>{{ data.displayNameFrom }}</td>
                    <td>{{ data.displayNameTo }}</td>
                    <td>{{ data.typeOfVehicle | titlecase}}</td>
                    <td>{{ data.mileage }}</td>
                    <td>
                      {{ this.currency }}
                      {{
                        (data?.isPrimaryCurrency ? data.perAdult : convertAmount(exchangeRate, data.perAdult)) | number:'1.2-2'
                      }}
                    </td>
                    <td>
                      {{ this.currency }}
                      {{
                        (data?.isPrimaryCurrency ? data.perChild : convertAmount(exchangeRate, data.perChild)) | number:'1.2-2'
                      }}
                    </td>
                    <td>
                      {{ this.currency }}
                      {{
                        (data?.isPrimaryCurrency ? data.perInfant: convertAmount(exchangeRate, data.perInfant)) | number:'1.2-2'
                      }}
                    </td>
                    <td>
                      {{ this.currency }}
                      {{
                        (data?.isPrimaryCurrency  ? data.totalCost  : convertAmount(exchangeRate, data.totalCost )) | number:'1.2-2'
                      }}
                    </td>
                  </tr>
                  </tbody>
                </nz-table>
              </div>
            </div>
          </div>
          <div *ngIf="
              this.singleItinerary.experiences[i].experiencesPerDay[0].experience !== undefined && !day.isLeisureDay
            " class="space-y-[15px] mt-7">
            <div class="flex flex-row justify-between">
              <h4>{{ 'itineraries.costBreakdown.experiences.title' | transloco }}</h4>
              <h4>{{ this.currency }} {{ this.calculateExperiencesCostPerDay(this.singleItinerary.experiences[i].experiencesPerDay) | number:'1.2-2' }}</h4>
            </div>

            <!-- perPerson table -->
            <ng-container *ngIf="hasExpOfType(singleItinerary.experiences[i].experiencesPerDay, SETTINGS.COST_TYPES_EXPERIENCES[1].value)">
              <h5 class="mt-4 mb-2">{{ 'itineraries.costBreakdown.experiences.perPerson' | transloco }}</h5>
              <div class="grid grid-cols-12">
                <div class="col-span-12">
                  <nz-table #expPersonTable [nzSize]="'small'" [nzScroll]="{ x: '600px' }"
                            [nzData]="getExpByType(singleItinerary.experiences[i].experiencesPerDay, SETTINGS.COST_TYPES_EXPERIENCES[1].value)"
                            [nzShowPagination]="false" [nzBordered]="true">
                    <thead>
                    <tr>
                      <th nzWidth="20%">{{ 'itineraries.costBreakdown.experiences.titleColumn' | transloco }}</th>
                      <th nzWidth="12%">{{ 'itineraries.costBreakdown.experiences.costPerAdult' | transloco }}</th>
                      <th nzWidth="12%">{{ 'itineraries.costBreakdown.experiences.costPerChild' | transloco }}</th>
                      <th nzWidth="12%">{{ 'itineraries.costBreakdown.experiences.costPerInfant' | transloco }}</th>
                      <th nzWidth="8%">{{ 'itineraries.costBreakdown.experiences.numberOfAdults' | transloco }}</th>
                      <th nzWidth="8%">{{ 'itineraries.costBreakdown.experiences.numberOfChildren' | transloco }}</th>
                      <th nzWidth="8%">{{ 'itineraries.costBreakdown.experiences.numberOfInfants' | transloco }}</th>
                      <th nzWidth="12%">{{ 'itineraries.costBreakdown.experiences.markupCost' | transloco }}</th>
                      <th nzWidth="12%">{{ 'itineraries.costBreakdown.experiences.totalCost' | transloco }}</th>
                      <th nzWidth="12%">{{ 'itineraries.costBreakdown.experiences.conditionType' | transloco }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of expPersonTable.data">
                      <td>{{ this.displayTitle(data.experience.titles, this.singleItinerary.tour.language) }}</td>
                      <td>{{ this.currency }} {{ (data?.isPrimaryCurrency ? data?.costPerAdult ?? 0 : convertAmount(exchangeRate, data?.costPerAdult ?? 0)) | number:'1.2-2' }}</td>
                      <td>{{ this.currency }} {{ (data?.isPrimaryCurrency ? data?.costPerChild ?? 0 : convertAmount(exchangeRate, data?.costPerChild ?? 0)) | number:'1.2-2' }}</td>
                      <td>{{ this.currency }} {{ (data?.isPrimaryCurrency ? data?.costPerInfant ?? 0 : convertAmount(exchangeRate, data?.costPerInfant ?? 0)) | number:'1.2-2' }}</td>
                      <td>{{ this.singleItinerary?.tour?.pax?.adults }}</td>
                      <td>{{ this.singleItinerary?.tour?.pax?.children }}</td>
                      <td>{{ this.singleItinerary?.tour?.pax?.infants }}</td>
                      <td>{{ this.currency }} {{ this.calculatePerPersonMarkup(data) | number:'1.2-2' }}</td>
                      <td>{{ this.currency }} {{ this.calculatePerPersonTotalCost(data) | number:'1.2-2' }}</td>
                      <td>
                        <ng-container *ngIf="getConditionBadge(data?.conditionType) as badge">
                          <span [ngClass]="badge.classes">{{ badge.label }}</span>
                        </ng-container>
                      </td>
                    </tr>
                    </tbody>
                  </nz-table>
                </div>
              </div>
            </ng-container>

            <!-- perGroup table -->
            <ng-container *ngIf="hasExpOfType(singleItinerary.experiences[i].experiencesPerDay, SETTINGS.COST_TYPES_EXPERIENCES[2].value)">
              <h5 class="mt-4 mb-2">{{ 'itineraries.costBreakdown.experiences.perGroup' | transloco }}</h5>
              <div class="grid grid-cols-12">
                <div class="col-span-12">
                  <nz-table #expGroupTable [nzSize]="'small'" [nzScroll]="{ x: '600px' }"
                            [nzData]="getExpByType(singleItinerary.experiences[i].experiencesPerDay, SETTINGS.COST_TYPES_EXPERIENCES[2].value)"
                            [nzShowPagination]="false" [nzBordered]="true">
                    <thead>
                    <tr>
                      <th nzWidth="20%">{{ 'itineraries.costBreakdown.experiences.titleColumn' | transloco }}</th>
                      <th nzWidth="12%">{{ 'itineraries.costBreakdown.experiences.cost' | transloco }}</th>
                      <th nzWidth="10%">{{ 'itineraries.costBreakdown.experiences.maximumPax' | transloco }}</th>
                      <th nzWidth="10%">{{ 'itineraries.costBreakdown.experiences.quantity' | transloco }}</th>
                      <ng-container *ngIf="hasAdvancedOptions(getExpByType(singleItinerary.experiences[i].experiencesPerDay, SETTINGS.COST_TYPES_EXPERIENCES[2].value))">
                        <th nzWidth="10%">{{ 'itineraries.costBreakdown.experiences.includedPax' | transloco }}</th>
                        <th nzWidth="10%">{{ 'itineraries.costBreakdown.experiences.extraPaxCost' | transloco }}</th>
                      </ng-container>
                      <th nzWidth="12%">{{ 'itineraries.costBreakdown.experiences.markupCost' | transloco }}</th>
                      <th nzWidth="12%">{{ 'itineraries.costBreakdown.experiences.totalCost' | transloco }}</th>
                      <th nzWidth="12%">{{ 'itineraries.costBreakdown.experiences.conditionType' | transloco }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of expGroupTable.data">
                      <td>{{ this.displayTitle(data.experience.titles, this.singleItinerary.tour.language) }}</td>
                      <td>{{ this.currency }} {{ (data?.isPrimaryCurrency ? data?.costing?.cost ?? 0 : convertAmount(exchangeRate, data?.costing?.cost ?? 0)) | number:'1.2-2' }}</td>
                      <td>{{ data?.costing?.maximumPax ?? 0 }}</td>
                      <td>{{ data?.costing?.quantity ?? 0 }}</td>
                      <ng-container *ngIf="hasAdvancedOptions(getExpByType(singleItinerary.experiences[i].experiencesPerDay, SETTINGS.COST_TYPES_EXPERIENCES[2].value))">
                        <td>{{ data?.advancedOptions?.includedPax ?? 0 }}</td>
                        <td>{{ this.currency }} {{ (data?.isPrimaryCurrency ? data?.advancedOptions?.extraPaxCost ?? 0 : convertAmount(exchangeRate, data?.advancedOptions?.extraPaxCost ?? 0)) | number:'1.2-2' }}</td>
                      </ng-container>
                      <td>{{ this.currency }} {{ calculatePerGroupMarkup(data) | number:'1.2-2' }}</td>
                      <td>{{ this.currency }} {{ calculatePerGroupTotalCost(data) | number:'1.2-2' }}</td>
                      <td>
                        <ng-container *ngIf="getConditionBadge(data?.conditionType) as badge">
                          <span [ngClass]="badge.classes">{{ badge.label }}</span>
                        </ng-container>
                      </td>
                    </tr>
                    </tbody>
                  </nz-table>
                </div>
              </div>
            </ng-container>

            <!-- free table -->
            <ng-container *ngIf="hasExpOfType(singleItinerary.experiences[i].experiencesPerDay, SETTINGS.COST_TYPES_EXPERIENCES[0].value)">
              <h5 class="mt-4 mb-2">{{ 'itineraries.costBreakdown.experiences.free' | transloco }}</h5>
              <div class="grid grid-cols-12">
                <div class="col-span-12">
                  <nz-table #expFreeTable [nzSize]="'small'" [nzScroll]="{ x: '600px' }"
                            [nzData]="getExpByType(singleItinerary.experiences[i].experiencesPerDay, SETTINGS.COST_TYPES_EXPERIENCES[0].value)"
                            [nzShowPagination]="false" [nzBordered]="true">
                    <thead>
                    <tr>
                      <th nzWidth="60%">{{ 'itineraries.costBreakdown.experiences.titleColumn' | transloco }}</th>
                      <th nzWidth="25%">{{ 'itineraries.costBreakdown.experiences.conditionType' | transloco }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of expFreeTable.data">
                      <td>{{ this.displayTitle(data.experience.titles, this.singleItinerary.tour.language) }}</td>
                      <td>
                        <ng-container *ngIf="getConditionBadge(data?.conditionType) as badge">
                          <span [ngClass]="badge.classes">{{ badge.label }}</span>
                        </ng-container>
                      </td>
                    </tr>
                    </tbody>
                  </nz-table>
                </div>
              </div>
            </ng-container>

          </div>

          <!-- Additional Costs per day -->
          <div *ngIf="singleItinerary.days[i]?.additionalCosts && singleItinerary.days[i].additionalCosts.length > 0"
               class="space-y-[15px] mt-7">
            <div class="flex flex-row justify-between">
              <h4>{{ 'itineraries.costBreakdown.additionalCosts.title' | transloco }}</h4>
              <h4>{{ this.currency }} {{ getDayAdditionalCostsTotal(singleItinerary.days[i]) | number:'1.2-2' }}</h4>
            </div>
            <div class="grid grid-cols-12">
              <div class="col-span-9">
                <nz-table #addCostTable [nzSize]="'small'" [nzScroll]="{ x: '400px' }"
                          [nzData]="singleItinerary.days[i].additionalCosts"
                          [nzShowPagination]="false" [nzBordered]="true">
                  <thead>
                  <tr>
                    <th nzWidth="60%">{{ 'itineraries.costBreakdown.additionalCosts.costName' | transloco }}</th>
                    <th nzWidth="40%">{{ 'itineraries.costBreakdown.additionalCosts.cost' | transloco }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let ac of addCostTable.data">
                    <td>{{ ac.title }}</td>
                    <td>{{ this.currency }} {{ (ac.cost ?? 0) | number:'1.2-2' }}</td>
                  </tr>
                  </tbody>
                </nz-table>
              </div>
            </div>
          </div>

          <div>
            <div class="flex flex-row justify-between">
              <h3>{{ 'itineraries.costBreakdown.dayCard.subTotalForDay' | transloco:{ day: (i + 1 | number : '2.0') } }} </h3>
              <h3>{{ this.currency }}
                {{
                  this.calculateSubTotalPerDay(
                    this.singleItinerary.days[i].isLeisureDay,
                    this.singleItinerary.experiences[i].experiencesPerDay,
                    day.transport,
                    getAccommodationPerDate(day.date, this.singleItinerary.accommodation),
                    singleItinerary.days[i]) | number:'1.2-2'
                }}
              </h3>
            </div>
          </div>
        </nz-card>
      </div>
      <nz-card class="px-8 py-8 md:px-12 md:py-8 bg-white space-y-[20px]">
        <h4>{{ 'itineraries.costBreakdown.costing.title' | transloco }}</h4>
        <nz-divider></nz-divider>
        <div class="space-y-[10px]" *ngIf="!this.singleItinerary?.costing?.costBreak; else alt">
          <div class="flex justify-between">
            <h4>{{ 'itineraries.costBreakdown.costing.subTotal' | transloco }}</h4>
            <h4>{{ this.currency }} {{ calculateTotalTourCost() | number:'1.2-2' }}</h4>
          </div>
          <div *ngIf="this.brand?.isMarkCostBefore" class="flex justify-between">
            <h4>{{ 'itineraries.costBreakdown.costing.markup' | transloco }}
              - {{ this.singleItinerary?.costing.markupRatio }} {{ getMarkupSymbolLabel(this.singleItinerary?.costing.markupSymbol) }}</h4>
            <h4>{{ this.currency }} {{ this.singleItinerary?.costing.markup | number:'1.2-2' }}</h4>
          </div>
          <div *ngIf="this.additionalCosts.length !== 0" class="flex justify-between">
            <h4>{{ 'itineraries.costBreakdown.costing.totalAdditionalCost' | transloco }}</h4>
            <h4>{{ this.currency }} {{ this.singleItinerary?.costing.totalAdditionalCost | number:'1.2-2' }}</h4>
          </div>
          <div *ngIf="this.additionalCosts.length !== 0" class="grid grid-cols-12">
            <div class="col-span-7">
              <nz-table #basicTable [nzSize]="'small'" [nzScroll]="{ x: '600px' }"
                        [nzData]="this.additionalCosts"
                        [nzShowPagination]="false" [nzBordered]="true">
                <thead>
                <tr>
                  <th nzWidth="20%">{{ 'itineraries.costBreakdown.costing.titleColumn' | transloco }}</th>
                  <th nzWidth="20%">{{ 'itineraries.costBreakdown.costing.costType' | transloco }}</th>
                  <th nzWidth="20%">{{ 'itineraries.costBreakdown.costing.value' | transloco }}</th>
                  <th nzWidth="15%">{{ 'itineraries.costBreakdown.costing.amount' | transloco }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let data of basicTable.data">
                  <td>{{ data.title }}</td>
                  <td>{{ getAdditionalCostTypeLabel(data.costCalSymbol) }}</td>
                  <td>{{ data.costCalSymbol !== "PERCENT" ? this.currency : "" }} {{ data.cost }} {{ data.costCalSymbol === "PERCENT" ? '%' : '' }}</td>
                  <td>
                    {{ this.currency }}
                    {{
                      data.costCalSymbol === "PERCENT" ?
                        (this.singleItinerary?.costing.totalCost / 100) * data.cost :
                        data.cost
                    }}
                  </td>
                </tr>
                </tbody>
              </nz-table>
            </div>
          </div>
          <div *ngIf="!this.brand?.isMarkCostBefore"  class="flex justify-between">
            <h4>{{ 'itineraries.costBreakdown.costing.markup' | transloco }}
              - {{ this.singleItinerary?.costing.markupRatio }} {{ getMarkupSymbolLabel(this.singleItinerary?.costing.markupSymbol) }}</h4>
            <h4>{{ this.currency }} {{ this.singleItinerary?.costing.markup | number:'1.2-2' }}</h4>
          </div>
          <div class="flex justify-between">
            <h3>{{ 'itineraries.costBreakdown.costing.totalTourCost' | transloco }}</h3>
            <h3>{{ this.currency }} {{ this.singleItinerary?.costing.grandTotal | number:'1.2-2' }}</h3>
          </div>
          <div class="flex justify-between">
            <h3>{{ 'itineraries.costBreakdown.costing.perPersonCost' | transloco }}</h3>
            <h3>{{ this.currency }} {{ this.singleItinerary?.costing.personCost | number:'1.2-2' }}</h3>
          </div>
        </div>
        <ng-template #alt>
          <div class="grid grid-cols-12">
            <div class="col-span-7">
              <nz-table #costPerPerson [nzSize]="'small'" [nzScroll]="{ x: '600px' }"
                        [nzData]="[this.singleItinerary.costing]"
                        [nzShowPagination]="false" [nzBordered]="true">
                <thead>
                <tr>
                  <th nzWidth="20%">{{ 'itineraries.costBreakdown.costing.costPerAdult' | transloco }}</th>
                  <th nzWidth="20%">{{ 'itineraries.costBreakdown.costing.costPerChild' | transloco }}</th>
                  <th nzWidth="20%">{{ 'itineraries.costBreakdown.costing.costPerInfant' | transloco }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let data of costPerPerson.data">
                  <td>{{ this.currency }} {{ data.costPerAdult | number:'1.2-2'}}</td>
                  <td>{{ this.currency }} {{ data.costPerChild | number:'1.2-2'}}</td>
                  <td>{{ this.currency }} {{ data.costPerInfant | number:'1.2-2'}}</td>
                </tr>
                </tbody>
              </nz-table>
            </div>
          </div>
        </ng-template>

      </nz-card>
      <nz-card *ngIf="!this.singleItinerary?.costing?.costBreak" class="px-8 py-8 md:px-12 md:py-8 bg-[#f5edff] space-y-[20px]">
        <h4>{{ 'itineraries.costBreakdown.costingBreakdown.title' | transloco }}</h4>
        <nz-divider></nz-divider>
        <div *ngIf="!this.singleItinerary?.costSettings?.isSubTotalManual" class="flex justify-between">
          <h4>{{ 'itineraries.costBreakdown.costingBreakdown.totalAccommodationCost' | transloco }}</h4>
          <h4>
            {{ this.currency }} {{ this.singleItinerary?.costing.totalAccommodation | number:'1.2-2' }}
          </h4>
        </div>
        <div *ngIf="!this.singleItinerary?.costSettings?.isSubTotalManual" class="flex justify-between">
          <h4>{{ 'itineraries.costBreakdown.costingBreakdown.totalTransportationCost' | transloco }}</h4>
          <h4>
            {{ this.currency }} {{ this.singleItinerary?.costing.totalTransport | number:'1.2-2' }}
          </h4>
        </div>
        <div *ngIf="!this.singleItinerary?.costSettings?.isSubTotalManual" class="flex justify-between">
          <h4>{{ 'itineraries.costBreakdown.costingBreakdown.totalExperiencesCost' | transloco }}</h4>
          <h4>
            {{ this.currency }} {{ this.singleItinerary?.costing.totalExperiences | number:'1.2-2' }}
          </h4>
        </div>
        <div class="flex justify-between">
          <h4>{{ 'itineraries.costBreakdown.costingBreakdown.totalAdditionalCost' | transloco }}</h4>
          <h4>
            {{ this.currency }} {{ (this.singleItinerary?.costing.totalAdditionalCost + getTotalDayAdditionalCosts()) | number:'1.2-2' }}
          </h4>
        </div>
        <div class="flex flex-col gap-2 mt-1 mb-2 pt-2 border-t border-gray-200">
          <div class="flex justify-between items-center">
            <span class="text-sm text-gray-500 flex items-center gap-1">
              <span nz-icon nzType="global" nzTheme="outline"></span>
              {{ 'itineraries.costBreakdown.costingBreakdown.tourWise' | transloco }}
            </span>
            <span class="text-sm">
              {{ this.currency }} {{ this.singleItinerary?.costing.totalAdditionalCost | number:'1.2-2' }}
            </span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-sm text-gray-500 flex items-center gap-1">
              <span nz-icon nzType="calendar" nzTheme="outline"></span>
              {{ 'itineraries.costBreakdown.costingBreakdown.dayWise' | transloco }}
            </span>
            <span class="text-sm">
              {{ this.currency }} {{ getTotalDayAdditionalCosts() | number:'1.2-2' }}
            </span>
          </div>
        </div>
        <div class="flex justify-between">
          <h4>{{ 'itineraries.costBreakdown.costingBreakdown.totalMarkup' | transloco }}</h4>
          <h4>
            {{ this.currency }} {{ this.singleItinerary?.costing.markup | number:'1.2-2' }}
          </h4>
        </div>
      </nz-card>
    </div>
  </section>
</nz-spin>
